import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { appRoutesObj } from "src/app.paths";

function RecoverPasswordEmailSentComponent() {
  const { i18n, t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div
      dir={i18n.language === "ar" ? "rtl" : "ltr"}
      className="flex flex-col justify-center items-center gap-4 w-[425px] mobile:mx-6"
    >
      <p className="text-center font-arMedium text-2xl text-black mobile:text-xl">
        {t("recoverPasswordEmailSent.component.messageWillBeSend")}
      </p>
      {/* home page Button */}
      <button
        type="button"
        onClick={() => navigate(appRoutesObj.getBasePath())}
        className="flex justify-center items-center font-arMedium text-xl mobile:text-xl text-zinc50 bg-mint-500 h-14 w-[345px] mobile:w-full rounded-2xl"
      >
        {t("app.shared.homepage")}
      </button>
    </div>
  );
}

export default RecoverPasswordEmailSentComponent;
